import { Stack } from "@fluentui/react/lib/Stack";

import { Card } from "Components/Generic/Card";
import { WithConfiguration } from "Components/Generic/Configuration";
import { KeyValueGrid } from "Components/Generic/KeyValueGrid";
import { Value } from "Components/Generic/KeyValueGrid/Value";
import { WithTranslator } from "Components/Generic/Translator";
import { IFieldMetadata } from "Model/Configuration/IFieldMetadata";
import { EntityType } from "Model/EntityType";
import { hasNoElements } from "Utils/Array";
import { Configuration } from "Utils/Configuration";
import { getTranslatedFieldLabel } from "Utils/Field";
import { getItemType } from "Utils/Item";
import { Description } from "./Description";
import { IInfoProps } from "./IInfoProps";
import { useInfoStyles } from "./UseInfoStyles";

export const Info = WithConfiguration(
  WithTranslator((props: IInfoProps): JSX.Element => {
    const {
      item, type, translator, config
    } = props;
    const { gridStyles, cardStyles } = useInfoStyles();

    const detailGroups = getDetailsConfig(config, type, item.dataSource as string);
    const descriptionFields = config.getDescriptions();

    if (hasNoElements(detailGroups)) {
      return null;
    }

    return (
      <>
        <Stack horizontal wrap>
          {detailGroups.map((fields, index) => (
            <Card
              // eslint-disable-next-line react/no-array-index-key
              key={`card.${index}`}
              styleSet={cardStyles}
            >
              <KeyValueGrid
                // eslint-disable-next-line react/no-array-index-key
                key={`box.${index}`}
                header={translator.get(`details.${type.toLowerCase()}.header.${index + 1}`, () => ``)}
                styleSet={gridStyles}
                items={fields.map((fieldMeta) => {
                  const { fieldName, isRequired = false } = fieldMeta;
                  return {
                    isRequired,
                    isEmpty: item?.[fieldName] == null,
                    key: getTranslatedFieldLabel(fieldName, getItemType(item), translator),
                    value: <Value {...fieldMeta} item={item} placeholder="-" />
                  };
                })}
              />
            </Card>
          ))}
        </Stack>
        <Stack>
          {descriptionFields.map((fieldName, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Description key={`descr.${index}`} item={item} fieldName={fieldName} />
          ))}
        </Stack>
      </>
    );
  })
);

function getDetailsConfig(config: Configuration, type: EntityType, dataSource: string): IFieldMetadata[][] {
  switch (type) {
    case EntityType.Project:
      return config.getDetailsProject(dataSource);
    case EntityType.Company:
      return config.getDetailsCompany(dataSource);
    case EntityType.Contact:
      return config.getDetailsContact(dataSource);
    default:
      return null;
  }
}
